import { Attributes } from '@leverege/ui-attributes';
import Groupings from "../../groupings/Groupings.js";
/**
 * Build a filter for the Value if it has a filter
 * @param {Object} val Value from the section
 * @param {string} field the section attribute field name for the objectType
 * @param {string} fieldType the data type of the field
 * @param {string} objectType the type of object we are filtering
 * @returns 
 */
function toFilter(val, field, fieldType, objectType) {
  const {
    value,
    filter
  } = val;
  let vf = null;
  if (value === Groupings.ALL_SECTION_VALUE) {
    // no
  } else if (Groupings.isMissing(value)) {
    vf = doesNotExist(field);
  } else {
    vf = equals(field, value, fieldType);
  }
  const f = filter && convertFilter(filter, objectType);
  return f || vf ? combine(vf, f) : null;
}

/**
 * Attempts to convert attributeNames in a filter to fields.
 * @param {} f 
 * @param {*} objectType 
 * @returns 
 */
function convertFilter(f, objectType) {
  if (f == null) {
    return f;
  }
  if (f.type === 'logical') {
    const nf = {
      ...f,
      conditions: f.conditions.map(cf => {
        return convertFilter(cf, objectType);
      }).filter(f => f != null)
    };
    if (nf.conditions.length === 0) {
      return null;
    }
    return nf;
  }
  if (f.type === 'equals' && f.attributeName) {
    const attr = Attributes.getAttribute(f.attributeName, objectType);
    const field = attr?.blueprint?.field;
    const fieldType = attr?.fieldType || attr.blueprint.attribute?.searchType || 'string';
    if (field && fieldType) {
      return equals(field, f.value, fieldType);
    }
    return null;
  }
  if (f.attributeName) {
    const attr = Attributes.getAttribute(f.attributeName, objectType);
    const field = attr?.blueprint?.field;
    if (field) {
      const r = {
        ...f,
        field
      };
      delete r.attributeName;
      return r;
    }
    return null;
  }
  return f;
}
function equals(field, value, fieldType) {
  return {
    type: 'equals',
    field,
    fieldType,
    value
  };
}

/**
 * Creates a Terms aggregate for the given field
 */
function terms(field, fieldType) {
  return {
    type: 'terms',
    field,
    fieldType,
    size: 1000
  };
}

/**
 * Creates a does not exist aggregation for the given field
 */
function doesNotExist(field) {
  return {
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'exists',
      not: true,
      field
    }]
  };
}
function logicalAnd(conditions) {
  return {
    type: 'logical',
    operator: 'and',
    conditions
  };
}
function isLogicalAnd(f) {
  return f.type === 'logical' && f.operator === 'and';
}

/**
 * Will combine a section and value filter and return a single filter
 */
function combine(sFilter, vFilter) {
  if (sFilter && vFilter) {
    if (isLogicalAnd(sFilter)) {
      if (isLogicalAnd(vFilter)) {
        return logicalAnd([...sFilter.conditions, ...vFilter.conditions]);
      }
      return logicalAnd([...sFilter.conditions, vFilter]);
    }
    if (isLogicalAnd(vFilter)) {
      return logicalAnd([...vFilter.conditions, sFilter]);
    }
    return logicalAnd([sFilter, vFilter]);
  }
  return sFilter || vFilter || null;
}
export default {
  toFilter,
  convertFilter,
  equals,
  combine,
  terms,
  doesNotExist
};